var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWindows = function SvgWindows(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 640 640",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.2 298.669 0 90.615l256.007-34.76v242.814zM298.658 49.654 639.905-.012v298.681H298.657V49.654zM640 341.331l-.071 298.681L298.669 592V341.332zM255.983 586.543.189 551.463v-210.18h255.794z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWindows);
export default ForwardRef;